import React, { useEffect, useState } from 'react'
import { useFinancialYearsQuery, useGetMasterSettingQuery, useGetTaxPercentListQuery, useUpdateMasterSettingMutation } from '../../../Store/Apis/toolsApi';
import Loader from '../../../Components/Loader/Loader';
import { useSelector } from 'react-redux';
import { useCountryCodeQuery } from '../../../Store/Apis/customerApi';
import toast from 'react-hot-toast';

const MasterSettings = () => {
  const user = useSelector((state) => state.auth.user);
  const { data: masterSettingsApiData, isLoading, isSuccess } = useGetMasterSettingQuery();
  const FinancialYearApiData = useFinancialYearsQuery();
  const [updateMasterSettingMutation] = useUpdateMasterSettingMutation()
  const countryCodes = useCountryCodeQuery()
  const taxPercentListQuery = useGetTaxPercentListQuery()

  const [formData, setFormData] = useState({
    appName: "",
    appLogo: "",
    favicon: "",
    phone: "",
    email: "",
    password: "",
    currencySymbol: "",
    taxPercentage: "",
    financialYear: "",
    country: "",
    state: "",
    city: "",
    district: "",
    zipCode: "",
    storeEmail: "",
    storeTaxNumber: "",
    address: "",
    printerPOS: "",
    orderPrefix: "",
    startTime: "",
    closeTime: "",
  });

  const [errors, setErrors] = useState({});
  const [appLogoPreview, setAppLogoPreview] = useState("");
  const [faviconPreview, setFaviconPreview] = useState("");

  const financialYearOptions = [
    "2023 [01/04/2023 to 31/03/2024]",
    "2022 [01/04/2022 to 31/03/2023]",
    "2021 [01/04/2021 to 31/03/2022]",
  ];
  const printerOptions = ["POS1", "POS2", "POS3"];
  const countryOptions = ["United States", "Canada", "United Kingdom", "Australia"];

  // Populate formData with API data
  useEffect(() => {
    if (masterSettingsApiData && masterSettingsApiData.data) {
      const apiData = masterSettingsApiData.data;

      setFormData({
        appName: apiData.default_application_name || "",
        appLogo: apiData.default_logo || "",
        favicon: apiData.default_favicon || "",
        phone: apiData.default_phone_number || "",
        email: apiData.store_email || "",
        password: "",
        currencySymbol: apiData.default_currency || "",
        taxPercentage: apiData.default_tax_percentage || "",
        financialYear: apiData.default_financial_year || "",
        country: apiData.default_country || "",
        state: apiData.default_state || "",
        city: apiData.default_city || "",
        district: apiData.default_district || "",
        zipCode: apiData.default_zip_code || "",
        storeEmail: apiData.store_email || "",
        storeTaxNumber: apiData.store_tax_number || "",
        address: apiData.default_address || "",
        printerPOS: apiData.default_printer || "",
        orderPrefix: apiData.order_prefix || "",
        startTime: apiData.store_start_time || "",
        closeTime: apiData.store_close_time || "",
      });

      setAppLogoPreview(apiData.default_logo || "");
      setFaviconPreview(apiData.default_favicon || "");
    }
  }, [masterSettingsApiData]);

  // Handle file input and preview
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setFormData({ ...formData, [type]: base64String });
        if (type === "appLogo") setAppLogoPreview(base64String);
        if (type === "favicon") setFaviconPreview(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  // Remove file preview
  const handleRemoveFile = (type) => {
    setFormData({ ...formData, [type]: "" });
    if (type === "appLogo") setAppLogoPreview("");
    if (type === "favicon") setFaviconPreview("");
  };

  // Handle form field changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.appName) newErrors.appName = "Application name is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.email) newErrors.email = "Email is required";
    // if (!formData.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(user)
    if (validateForm()) {
      const apiBody = {
        default_currency: formData.currencySymbol || "",
        default_application_name: formData.appName || "",
        default_phone_number: formData.phone || "",
        default_tax_percentage: formData.taxPercentage || "",
        default_state: formData.state || "",
        default_city: formData.city || "",
        default_country: formData.country || "",
        default_zip_code: formData.zipCode || "",
        default_address: formData.address || "",
        store_email: formData.storeEmail || "",
        store_tax_number: formData.storeTaxNumber || "",
        default_printer: formData.printerPOS || "",
        default_financial_year: formData.financialYear || "",
        default_district: formData.district || "",
        default_logo: formData.appLogo || "",
        order_prefix: formData.orderPrefix || "",
        store_start_time: formData.startTime || "",
        store_close_time: formData.closeTime || "",
        address: formData.address || "",
        default_favicon: formData.favicon || "",
        outlet: user.outletID.toString()
      };
  
      updateMasterSettingMutation(apiBody).then((res) => {
        if(res.data.status == 200){
          toast.success(res.data.message)
        }
      });
    }
  };

  return (
    <>
      <h5 class="fw-500 text-white mb-3">Master Settings</h5>
      <div className='card mb-4'>
        <div className="card-body p-4">
          {
            isLoading && (
              <Loader height={400}/>
            )
          }
          {
            isSuccess && (
              <form onSubmit={handleSubmit}>
                {/* Application Details Section */}
                <h6 className='mb-2'>Application Details</h6>
                <div className="row gy-3 mb-4">
                  {/* Application Name */}
                  <div className="col-md-4">
                    <label>Application Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="appName"
                      value={formData.appName}
                      onChange={handleChange}
                    />
                    {errors.appName && <small className="text-danger">{errors.appName}</small>}
                  </div>

                  {/* App Logo */}
                  <div className="col-md-4">
                    <label>App Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "appLogo")}
                    />
                    {appLogoPreview && (
                      <div className='position-relative mt-2' style={{maxWidth: '150px'}}>
                        <img src={appLogoPreview} alt="App Logo" className="preview  w-100"/>
                        <button 
                          class="badge bg-danger btn btn-danger mb-0 px-2 py-1" 
                          title="Delete Image" 
                          onClick={() => handleRemoveFile("appLogo")}
                          style={{position: 'absolute', top: '10px', right: '10px'}}
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Favicon */}
                  <div className="col-md-4">
                    <label>Favicon</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "favicon")}
                    />
                    {faviconPreview && (
                      <div className='position-relative mt-2' style={{maxWidth: '150px'}}>
                        <img src={faviconPreview} alt="Favicon" className="preview w-100"/>
                        <button 
                          class="badge bg-danger btn btn-danger mb-0 px-2 py-1" 
                          title="Delete Image" 
                          onClick={() => handleRemoveFile("favicon")}
                          style={{position: 'absolute', top: '10px', right: '10px'}}
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-4">
                    <label>Phone Number *</label>
                    <input
                      type="number"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && <small className="text-danger">{errors.phone}</small>}
                  </div>

                  {/* Email */}
                  <div className="col-md-4">
                    <label>Email *</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>

                  {/* Password */}
                  <div className="col-md-4">
                    <label>Password *</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    {errors.password && <small className="text-danger">{errors.password}</small>}
                  </div>
                </div>


                {/* Firm Address Section */}
                <h6 className='mb-2'>Firm Address</h6>
                <div className="row gy-3 mb-4">                  
                  <div className="col-md-4">
                    <label>Country</label>
                    <select 
                      className="form-control" 
                      name="country" 
                      onChange={handleChange}
                      value={formData.country}
                    >
                      <option value="">Select Country</option>
                      {
                          countryCodes?.data?.data.map((elem, i)=>{
                            return(
                              <option value={elem.countryCode}>{elem.countryName}</option>
                            )
                          })
                      }
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>State</label>
                    <input type="text" className="form-control" name="state" value={formData.state} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>City</label>
                    <input type="text" className="form-control" name="city" value={formData.city} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>District</label>
                    <input type="text" className="form-control" name="district" value={formData.district} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Zip Code</label>
                    <input type="number" className="form-control" name="zipCode" value={formData.zipCode} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Store Email</label>
                    <input type="email" className="form-control" name="storeEmail" value={formData.storeEmail} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Store Tax Number</label>
                    <input type="text" className="form-control" name="storeTaxNumber" value={formData.storeTaxNumber} onChange={handleChange} />
                  </div>
                  <div className="col-md-12">
                    <label>Address</label>
                    <textarea className="form-control" name="address" rows="3" value={formData.address} onChange={handleChange}></textarea>
                  </div>
                </div>

                {/* Other Settings Section */}
                <h6 className='mb-2'>Other Settings</h6>
                <div className="row gy-3 mb-4">                  
                  <div className="col-md-4">
                    <label>Printer POS</label>
                    <select className="form-control" name="printerPOS" onChange={handleChange}>
                      <option value="">Select Printer</option>
                      {printerOptions.map((printer, idx) => (
                        <option key={idx} value={printer}>{printer}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Order Prefix</label>
                    <input type="text" className="form-control" name="orderPrefix" value={formData.orderPrefix} onChange={handleChange} />
                  </div>
                </div>

                {/* Finance Settings Section */}
                <h6 className='mb-2'>Finance Settings</h6>
                <div className="row gy-3 mb-4">
                  <div className="col-md-4">
                    <label>Currency Symbol</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      name="currencySymbol" 
                      value={formData.currencySymbol}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Tax Percentage</label>
                    {/* <input 
                      type="number" 
                      className="form-control" 
                      name="taxPercentage" 
                      value={formData.taxPercentage}
                      onChange={handleChange}
                    /> */}

                    <select
                      className="form-select" 
                      name="taxPercentage" 
                      value={formData.taxPercentage}
                      onChange={handleChange}
                    >
                      {
                        taxPercentListQuery?.data?.data.map((elem, idx) => (
                          <option key={idx} value={elem.percentage}>
                            {elem.percentage}
                          </option>
                        ))
                      }                      
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Financial Year</label>
                    <select className="form-control" name="financialYear" value={Number(formData.financialYear)} onChange={handleChange}>
                      <option value="">Select Year</option>
                      {FinancialYearApiData?.data?.data.map((elem, idx) => (
                        <option key={idx} value={elem.id}>
                          {`${elem.year} [${elem.startingDate.split('T')[0]} to ${elem.endingDate.split('T')[0]}]`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Store Settings Section */}
                <h6 className='mb-2'>Store Settings</h6>
                <div className="row gy-3 mb-4">
                  <div className="col-md-4">
                    <label>Start Time</label>
                    <input 
                      type="time"
                      className="form-control"
                      name="startTime"
                      value={formData.startTime}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Close Time</label>
                    <input 
                      type="time" 
                      className="form-control" 
                      name="closeTime" 
                      value={formData.closeTime}
                      onChange={handleChange} />
                  </div>
                </div>

                {/* Submit Button */}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">Save Settings</button>
                </div>
              </form>
            )
          }
        </div>
      </div>
    </>
  );
}

export default MasterSettings